import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
// tslint:disable-next-line: class-name
export class authenticationService {
  headers = new HttpHeaders();
  token: string;
  constructor(private route: Router) {
    this.token = sessionStorage.getItem('serviceAdmintoken');
  }

  checkAuthentication() {
    if (this.token == null) {
      this.route.navigate(['/login']);
      return 401;
    }
  }

  createAuthorizationHeader() {
    if (this.token == null) {
      return 401;
    } else {
      this.headers = new HttpHeaders({
        "ngrok-skip-browser-warning": 'true',
        Authorization: 'Bearer ' + this.token,
      });
    }
  }

  get Header() {
    if (this.headers != null) return this.headers;
  }
}
